<template>
  <div v-if="permission">
    <el-dropdown trigger="click" :hide-on-click="false" v-if="permission.edit" @visible-change="loadList()">
      <div class="profile-list">
        <el-button type="info" style="margin-left:10px;">
          <div class="profile-list-count" v-if="list_count">{{ list_count }}</div>
          <font-awesome-icon :icon="['far', 'list']" style="margin-right:3px" />リストに追加
          <font-awesome-icon icon="caret-down" style="margin-left:5px" />
        </el-button>
      </div>
      <el-dropdown-menu slot="dropdown" class="list-select">
        <div class="dropdown-search">
          <el-input class="dropdown-input" placeholder="リストを検索" prefix-icon="el-icon-search" size="large" clearable v-model="search_word" @input="loadListDebounced()"></el-input>
        </div>
        <div
          class="add-list-dropdown"
          v-for="(list, index) in list"
          :key="list.list_id"
          @click="list.influencer_in == 1 ? '' : addInfluencer(list.list_id, list.list_name, index)"
          :class="list.influencer_in == 1 ? 'assign' : ''"
        >
          <div class="flex-row" style="width:100%">
            <div class="loader--mini add-list" v-if="add_delete_index == index && add_delete_loading"></div>            
            <svg v-else-if="list.sns_type === 'twitter'" style="margin-right:5px" width="9" height="9" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
            </svg>            
            <font-awesome-icon :icon="['fab', list.sns_type]" style="margin-right:5px" v-else/>
            <div class="dropdown_listname">{{ list.list_name }}</div>
            <div class="flex-space"></div>
            <span>{{ list.influencer_num }}</span>
            <div v-if="list.influencer_in == 1" class="pointer times-circle" @click="deleteInfluencer(list.list_id, list.list_name, index)">
              <font-awesome-icon icon="times-circle" class="pointer" />
            </div>
          </div>
        </div>
        <div v-show="result_count == 0 && !loading" class="add-list-dropdown-nolist">リストがありません</div>
        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results" style="font-size:40px;"></div>
        </infinite-loading>
        <el-dropdown-item class="new-list" icon="el-icon-plus" @click.native="create_list = true" :disabled="activate == 12 && active_list_count >= 10" divided>新規リスト作成</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="profile-list" v-else>
      <el-button type="info" size="medium" style="margin-left:10px;" @click="openUnpermittedDrawer()">
        <div class="profile-list-count" v-if="list_count > 0">{{ list_count }}</div>
        <font-awesome-icon :icon="['far', 'list']" style="margin-right:3px" />リストに追加
        <font-awesome-icon icon="caret-down" style="margin-left:5px" />
      </el-button>
    </div>

    <createList :create_list.sync="create_list" @loadList="loadList" @addInfluencer="addInfluencer" :type="'add'" :sns_type="sns_type" />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadListAPI = root + "/api/list/load_list";
import createList from "../../list/createList";

export default {
  props: ["influencer_id", "sns_type", "list_count", "add_delete_index", "add_delete_loading"],
  name: "addListDetail",
  components: {
    createList,
  },
  data() {
    return {
      loading: false,
      list: [],
      result_count: 0,
      active_list_count: "",
      search_word: "",
      create_list: false,
      offset: 0,
      infiniteId: +new Date(),
      requestId: +new Date() + 10000,
      timer: null,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {},
  methods: {
    infiniteHandler($state) {
      if (this.permission && this.permission.edit) {
        this.loading = true;
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        this.axios
          .get(loadListAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              type: "min",
              offset: this.offset,
              search_word: this.search_word,
              sns_type: this.sns_type,
              influencer: this.influencer_id,
            },
          })
          .then((response) => {
            if (this.offset == 0) {
              this.list = response.data.mylist;
              this.result_count = response.data.result_count;
              this.active_list_count = response.data.active_list_count;
            } else {
              this.list = this.list.concat(response.data.mylist);
            }
            $state.loaded();
            this.offset += 40;
            this.loading = false;
            if (this.result_count <= this.offset) $state.complete();
          });
      }
    },
    loadList() {
      this.list = [];
      this.offset = 0;
      this.result_count = 0;
      this.infiniteId += 1;
    },
    deleteInfluencer(id, name, index) {
      this.$emit("deleteInfluencer", id, name, index);
      setTimeout(() => {
        if (this.list[index]) {
          this.list[index].influencer_in = false;
          this.list[index].influencer_num += -1;
        }
      }, 100);
    },
    addInfluencer(id, name, index) {
      this.$emit("addInfluencer", id, name, index);
      if (index != null){
        this.list[index].influencer_in = true;
        this.list[index].influencer_num += 1;
      }
    },
    openUnpermittedDrawer() {
      this.$store.dispatch("openUnpermittedDrawer", true);
    },
    loadListDebounced() {
      clearTimeout(this.timer);
      // 関数の実行をスケジュール
      this.timer = setTimeout(this.loadList, 300);
    }
  },
  filters: {},
  watch: {
    //mounted時にpermissionが読み込めないとloadListが実行されないため
    permission() {
      // this.loadList();
    },
  },
};
</script>

<style></style>
